<template>
  <div class="sidebar sidebarToggle">
    <sidebar-toggle :open="open" :toggle="toggle" :end="JourneyEnd"></sidebar-toggle>
    <nav class="sidebar-nav" style="height:100%;overflow-y:auto">
      <div class="row flex-xl-nowrap">
        <div class="col-12 col-md-12 col-xl-12 bd-sidebar">
          <div class="bd-content">
            <sidebar-content></sidebar-content>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { TweenMax, Power3 } from "gsap";
import SideBarContent from "./SideBar-Content.vue";
import SidebarToggle from "./SideBarToggle.vue";
import SideBarToggleAfterTimer from "./SideBarToggleAfterTimer.vue";

export default {
  name: "SideBar",
  components: {
    "sidebar-content": SideBarContent,
    "sidebar-toggle": SidebarToggle,
    "sidebar-toggle-after-timer": SideBarToggleAfterTimer
  },
  data() {
    return {
      open: false
    };
  },
  props: {
    JourneyEnd: {
      type: Boolean
    },
    chosenIndustry: {
      type: String
    }
  },
  mounted() {
    TweenMax.set(this.$el, {
      x: this.$el.offsetWidth
    });
  },

  methods: {
    toggle() {
      if (this.JourneyEnd) {
        this.open = !this.open;
      }
    }
  },

  // computed: {
  //   open() {
  //     if (this.JourneyEnd == true) {
  //       return true;
  //     }
  //     return this.$store.state.ui.sidebarOpen;
  //   },
  //   show() {
  //     return this.$store.getters.sidebarReactivate;
  //   }
  // },
  watch: {
    open: function(open) {
      let dX = this.open ? 0 : this.$el.offsetWidth;
      TweenMax.to(this.$el, 0.2, {
        x: dX,
        ease: Power3.easeOut
      });
    },
    JourneyEnd() {
      this.toggle();
    }
  }
};
</script>

<style lang="scss">
.sidebarToggle {
  background-image: url("../assets/sidebarToggleBackground.png");
  .sidebarHighlight {
    span.white-text {
      font-size: 0.8rem;
    }
  }
  .white-toggle {
    position: absolute;
    display: inline-block;
    background-color: #eaeaea;
    border-radius: 50%;
    transition: 300ms;
    width: 45px;
    height: 45px;
  }
  .blue-toggle {
    position: absolute;
    display: inline-block;
    background-color: #03b6fc;
    border-radius: 50%;
    transition: 500ms;
    width: 45px;
    height: 45px;
    display: none;
  }
  .toggle-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    #hide-checkbox {
      opacity: 0;
      height: 0;
      width: 0;
      &:checked + .toggle .toggle-button {
        transform: translateX(45px);
        box-shadow: 0 0 35px 5px rgba(255, 255, 255);
      }
      &:checked + .toggle .toggle-button .white-toggle {
        transform: rotate(-45deg) translateX(0px);
        background-color: #03b6fc;
      }
      &:checked + .toggle .blue-toggle {
        animation: move 2s infinite;
        transform: none;
        box-shadow: none;
      }
    }
    .toggle {
      position: relative;
      cursor: pointer;
      display: inline-block;
      width: 93px;
      height: 45px;
      background: #fff;
      border-radius: 50px;
      transition: 500ms;
      overflow: hidden;
    }
    .toggle-button {
      position: absolute;
      display: inline-block;
      top: 0px;
      left: 4px;
      width: 45px;
      height: 45px;
      border-radius: 50%;
      background: #eaeaea;
      overflow: hidden;
      box-shadow: 0 0 35px 4px rgba(255, 255, 255);
      transition: all 500ms ease-out;
      -moz-transition: all 500ms ease-out;
      -webkit-transition: all 500ms ease-out;
    }
    .flex-xl-nowrap {
      height: 100%;
    }
    @keyframes travel {
      0% {
        transform: rotate(-45deg) translateX(70px);
        -moz-transform: rotate(-45deg) translateX(70px);
        -webkit-transform: rotate(-45deg) translateX(70px);
      }
      50% {
        transform: rotate(-45deg) translateX(-20px);
        -webkit-transform: rotate(-45deg) translateX(-20px);
        -moz-transform: rotate(-45deg) translateX(-20px);
        box-shadow: 5px 0px 6px 1px #fff;
      }
      100% {
        transform: rotate(-45deg) translateX(-30px);
        -moz-transform: rotate(-45deg) translateX(-30px);
        -webkit-transform: rotate(-45deg) translateX(-30px);
        width: 2px;
        height: 2px;
        opacity: 0;
        box-shadow: none;
      }
    }
    @keyframes move {
      0% {
        transform: none;
        -moz-transform: none;
        -webkit-transform: none;
      }

      25% {
        transform: translateX(2px);
        -moz-transform: translateX(2px);
        -webkit-transform: translateX(2px);
      }

      100% {
        transform: translateX(-2px);
        -moz-transform: translateX(-2px);
        -webkit-transform: translateX(-2px);
      }
    }
  }
}
</style>
